import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import '@mantine/core/styles.css';
import '@mantine/dates/styles.css';
import { Auth0Provider } from '@auth0/auth0-react';

const domain = process.env.REACT_APP_AUTH0_DOMAIN;
const clientId = process.env.REACT_APP_AUTH0_CLIENTID;
const audience = process.env.REACT_APP_AUTH0_AUDIENCE;
const redirectUri = window.location.origin + '/Home';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Auth0Provider
      domain={domain}
      clientId={clientId}
      authorizationParams={{ redirect_uri: redirectUri, audience }}
      cacheLocation="localstorage"
      useRefreshTokens={false}
      sessionCheckExpiryDays={0}
    >
      <App />
    </Auth0Provider>
  </React.StrictMode>
);

reportWebVitals();
